module.exports = __webpack_public_path__ + "static/allorganicbowteether-da9572c9630dc4810cbf8d0f31e1c298.png";